 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A2CHAPTER01 from '@/components/02-chapter01'
 import A3CHAPTER02 from '@/components/03-chapter02'
 import A4CHAPTER03 from '@/components/04-chapter03'
 import A5CHAPTER04 from '@/components/05-chapter04'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
		{
 			"path" : "/",
 			"name" : "home",
 			"components" : {
				default: Home
			}
 		},
 		{
 			"path" : "/tcpage1",
 			"name" : "tcpage1"
 			,"components" : {
				 left: A2CHAPTER01
				 ,
				 right: A3CHAPTER02
			}
 		},
 		{
 			"path" : "/tcpage2",
 			"name" : "tcpage2"
 			,"components" : {
				 left: A4CHAPTER03
				 ,
				 right: A5CHAPTER04
			}
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"components" : {
				default: Last
			}
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js